<template>

  <popup
    v-if="addSite || siteData"
    :buttonStyle='this.addSite ? "success" : "info"'
    :heading='this.addSite ? "New Site" : "Update Site"'
    buttonSize="default"
    size="medium"
    :disable-button="!isManager('project|maintenance|property|finance|admin|management')"
    :button-text='addSite ? "Add" : "Edit"'
    :button-icon='addSite ? "fa fa-tower-broadcast"
    : "fa fa-pencil-alt"'
    @save="onSaveDialog"
    @close="onCloseDialog">

  <el-form ref='siteForm' :model="site" :rules="rules" label-position="top" inline>

      <el-row type="flex" justify="center">
        <el-col :span="24" align="center">
          <h4>Site Name: <span :class="titleClass(site.status)">{{site.siteName ? site.siteName : 'not entered'}}</span></h4>
        </el-col>
      </el-row>

      <el-tabs v-model="tab" type="border-card">

        <el-tab-pane label="Details" name="site">

          <div v-if="site.status === this.soldSite()">
            <el-alert type="error" :closable="false" show-icon title="Sold Site Warning!" description="If you save, ALL sharers will be set to 'Terminated'! Plus you won't be able to edit site details anymore." />
          </div>

          <select-site-status
            ref="selectSite"
            label="Status"
            v-model="site.status"
            required
            :disabled="this.isDisabled(originalSite, site, 'status')" />


          <text-input
            label="Site Name"
            prop="siteName"
            required
            v-model="site.siteName"
            placeholder="Site Name"
            :disabled="this.isDisabled(originalSite, site, 'siteName')" />

          <text-input
            label="Site ID"
            prop="siteId"
            required
            v-model="site.siteId"
            placeholder="Site ID"
            :max-length="16"
            :disabled="this.isDisabled(originalSite, site, 'siteId')" />

          <text-input
              label="Site Group"
              prop="siteGroup"
              v-model="site.siteGroup"
              placeholder="Site Group"
              :max-length="16"
              :disabled="this.isDisabled(originalSite, site, 'siteGroup')" />

        <select-coverage
            v-model="site.coverage"
            label="Coverage"
            :disabled="this.isDisabled(originalSite, site, 'coverage')" />

          <date-input
            v-model="site.handover"
            label="Handover"
            prop="handover"
            :disabled="this.isDisabled(originalSite, site, 'handover')" />

          <date-input
            v-if="site.status === this.activeSite()"
            v-model='site.active'
            label="Active"
            prop="active"
            :disabled="this.isDisabled(originalSite, site, 'active')" />

          <date-input
              v-if="site.status === this.dismantledSite()"
              v-model='site.dismantled'
              label="Dismantled"
              prop="dismantled"
              :disabled="this.isDisabled(originalSite, site, 'dismantled')" />


          <el-row>
            <el-col :span="24" align="center">
              <check-box v-if="!addSite && isManager('project|management')" v-model="override"><b>Manager Only!</b> Change existing data?</check-box>
            </el-col>
         </el-row>

        </el-tab-pane>


        <el-tab-pane label="Candidate" v-if="addSite && this.isCandidate(site.status)">
          <el-row>
            <el-col :span="24">
              <select-sharer v-model="candidate.client_id" />

              <text-input
                   label="Your Ref"
                   v-model="candidate.clientRef"
                   placeholder="Your Ref"
                   :max-length="16"
                    />

              <text-input
                   label="Title"
                   v-model="candidate.title"
                   placeholder="Title"
                   :max-length="88"
                    />

               <select-coverage
                   v-model="candidate.stationType"
                   label="Station Type"
                    />

              <integer-input
                  label="Antenna AGL"
                  :min="1"
                  :max="121"
                  suffix="m."
                  placeholder="Height above ground in metres"
                  v-model="candidate.antennaHeight"
                  />


            </el-col>
          </el-row>

        </el-tab-pane>

        <el-tab-pane v-if="addSite && !isLandOnly(site.status) && struct" label="Structure" name="structure">

          <el-row :gutter="guts">
            <el-col :span="24">

              <select-structure
                label="Structure Type"
                v-model="struct.structure_id"
                :disabled="isDisabled(originalStruct, struct, 'structure_id')" />

              <select-tower-supplier
                v-model="struct.supplier_id"
                :disabled="isDisabled(originalStruct, struct, 'supplier_id')" />

            </el-col>
          </el-row>

          <el-row :gutter="guts">
              <el-col :span="24">
                <integer-input
                  label="Structure Height"
                  :min="1"
                  :max="121"
                  suffix="m."
                  v-model="struct.height"
                  :disabled="isDisabled(originalStruct, struct, 'height')" />

              <integer-input
                label="Design Weight"
                :min="1"
                :max="121"
                suffix="kgs."
                placeholder="weight in kgs."
                v-model="struct.weight"
                :disabled="isDisabled(originalStruct, struct, 'weight')" />

              </el-col>
          </el-row>

          <el-row :gutter="guts">
            <el-col :span="24">

              <integer-input
                  label="Site Width"
                  v-model="struct.width"
                  suffix="m."
                  placeholder="width in metres"
                  :disabled="this.isDisabled(originalStruct, struct, 'width')" />

              <integer-input
                  label="Site Depth"
                  v-model="struct.depth"
                  suffix="m."
                  placeholder="depth in metres"
                  :disabled="this.isDisabled(originalStruct, struct, 'depth')" />

            </el-col>
          </el-row>

        </el-tab-pane>



        <el-tab-pane label="Locality" name="locality">

          <el-row :gutter="guts">
            <el-col :xs="24" :sm="24" :md="12" :lg="8">
              <text-input
                style="width: 100%; height: 100px;"
                label="Address"
                type="textarea"
                v-model="site.address"
                placeholder="Site Address"
                :disabled="this.isDisabled(originalSite, site, 'address')" />
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="8">
                <text-input
                  label="Post Code"
                  prop="postCode"
                  v-model="site.postCode"
                  placeholder="Post Code"
                  :disabled="this.isDisabled(originalSite, site, 'postCode')" />
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="8">
                  <select-locality
                    label="District"
                    v-model="loc"
                    :disabled="isDisabled(originalSite,
                      site,
                      ['zone','subdistrict', 'district', 'state', 'region', 'country'])"  />
              </el-col>

          </el-row>

          <hr />

          <el-row :gutter="guts">
            <el-col :span="8" align="center">

              <float-input
                v-if="!movePos"
                type="number"
                :decimals="12"
                v-model="site.latitude"
                placeholder="Latitude"
                prefix="Lat"
                suffix="&deg;"
                :disabled="this.isDisabled(originalSite, site, 'latitude')" />
                <span v-else>Latitude:&nbsp;<b>{{site.latitude}}</b>&deg;</span>

            </el-col>

            <el-col :span="8" align="center">

              <float-input
                v-if="!movePos"
                :decimals="12"
                type="number"
                v-model="site.longitude"
                placeholder="Longitude"
                prefix="Lng" suffix="&deg;"
                :disabled="this.isDisabled(originalSite, site, 'longitude')" />
                <span v-else>Longitude:&nbsp;<b>{{site.longitude}}</b>&deg;</span>

            </el-col>

            <el-col :span="8" align="center">

              <float-input
                type="number"
                :decimals="2"
                v-model="site.agl"
                placeholder="AGL"
                prefix="AGL"
                suffix="&deg;"
                :disabled="this.isDisabled(originalSite, site, 'latitude')" />

            </el-col>


          </el-row>

          <google-map
            v-if="this.site.latitude && this.site.longitude"
            :lat="this.site.latitude"
            :lng="this.site.longitude"
            draggable
            :zoom="14"
            width="100%"
            height="41.7vh"
            @update="updateSiteMap" />


        </el-tab-pane>


        <el-tab-pane v-if="addSite" label="Tenancy" name="tenancy">
          <update-tenancy
            :site-data="site"
            :tenancy-data="tenancy"
            adding
            editable
            no-disable
            @update="updateTenancy" />
        </el-tab-pane>



        <el-tab-pane v-if="addSite && !isLandOnly(site.status) && finance" label="Finance" name="finance">

            <number-input
              v-model="finance.capex"
              label="Site CAPEX"
              prop="capex"
              placeholder="Site CAPEX"
              :disabled="this.isDisabled(originalFinance, finance, 'capex')" />

            <number-input
              v-model="finance.opex"
              label="Site OPEX"
              prop="opex"
              placeholder="Site OPEX"
              :disabled="this.isDisabled(originalFinance, finance, 'opex')" />

        </el-tab-pane>

      </el-tabs>


</el-form>

</popup>

</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import SiteMixins from '@/mixins/SiteMixins'

import SelectCoverage from '@/components/atoms/selects/SelectCoverage'
import SelectLocality from '@/components/atoms/selects/SelectLocality'

import SelectSiteStatus from '@/components/atoms/selects/SelectSiteStatus'
import SelectSharer from '@/components/atoms/selects/SelectSharer'
import SelectStructure from '@/components/atoms/selects/SelectStructure'
import SelectAuthority from '@/components/atoms/selects/SelectAuthority'

import SelectTowerSupplier from '@/components/atoms/selects/SelectTowerSupplier'

import UpdateTenancy from '@/components/property/UpdateTenancy'

import GoogleMap from '@/components/atoms/GoogleMap'

import {ENABLE_SAVE_EVENT} from '@/components/Data'  // , DISABLE_SAVE_EVENT

export default {
  mixins: [SiteMixins],

  components: {
    GoogleMap,
    SelectAuthority,
    SelectCoverage,
    SelectLocality,
    SelectSharer,
    SelectStructure,
    SelectSiteStatus,
    SelectTowerSupplier,
    UpdateTenancy
  },


  props: {

    addSite: {
      type: Boolean,
      default: false
    },

    siteData: {
      type: Object
    },

    tableRef: {
      type: String,
      default: 'sitetable'
    },

    status: {
      type: String,
      default: null
    }

  },



  methods: {

    updateTenancy (tenancy) {
      this.tenancy = tenancy
      this.site.tenancy = tenancy
    },

    updateSiteMap (pos) {
      this.movePos = true
      this.site.latitude = pos.lat
      this.site.longitude = pos.lng
    },

    resetData () {
      this.site = this.clone(this.siteData)
    },

    onSaveDialog () {

      this.site.region = this.setProp(this.site.region, this.loc[0])
      this.site.state = this.setProp(this.site.state, this.loc[1])
      this.site.district = this.setProp(this.site.district, this.loc[2])
      this.site.subdistrict = this.setProp(this.site.subdistrict, this.loc[3])

    /*  this.site.zone = this.site.zone.name ? this.site.zone.name : null */

      this.site.handover = this.formatDateSql(this.site.handover)
      this.site.active = this.formatDateSql(this.site.active)
      this.site.dismantled = this.formatDateSql(this.site.dismantled)

      this.site.latitude = Number(this.site.latitude)
      this.site.longitude = Number(this.site.longitude)


      if (this.addSite) {

        if (this.struct.length >= 0) {
          this.site.structure = this.struct
        }


        if (this.tenancy.length >= 0) {
          this.site.tenancy = this.tenancy
        }

        if (this.finance.length >= 0) {
          this.site.finance = this.finance
        }

        if (this.candidateSite()) {
          this.candidate.markers = [{infoText: 'Option 1', icon: 'static/map/green-map.png', type: 'option', position: {lat: this.site.latitude, lng: this.site.longitude}}]
        }

      }

//      this.site.candidate = this.candidate
//      console.log('About to save: ', this.site)

      this.saveForm(this, '/sites', (this.addSite ? null : this.site.id), this.site, this.site.siteName, this.success)
      this.$emit('update-stats')
      this.resetData()
    },



    success (data) {
      this.originalSite = data
      this.$emit('change', data)
      this.$events.fire(this.tableRef + '-refresh-table')
    },


    onCloseDialog () {
      this.resetData()
    },


    isDisabled (source, target, prop) {

      if (this.addSite || this.override) {
        return false
      } else {

//        console.log(prop, ' = ', source.hasOwnProperty(prop), source[prop])

        if (prop && source && source.hasOwnProperty(prop) && source[prop] !== null) {
          return true
        } else {
          return false
        }
      }
    }

  },


  watch: {
    status: function (value) {
      if (value !== 'All' && this.addSite) {
        this.site.status = value
      }
//      console.log('status changed', this.site.status, value)
    }

  },



  data () {

    return {
      guts: 12,
      movePos: false,
      override: false,
      utilLabel: this.getUtilLabel(this.siteData),
      tab: 'site',
      loc: [],
      site: this.addSite ? this.getTableStruct('sites') : this.clone(this.siteData),
      originalSite: this.siteData,
      candidate: {},
      finance: {},
      struct: {},
      tenancy: {},
      originalStruct: {},
      originalFinance: {},
      originalTenancy: {},
      rules: {
        siteName: [
          { required: true, message: 'Please enter site name', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Please enter site status', trigger: 'blur' }
        ],
        siteId: [
          { required: true, message: 'Please enter site ID', trigger: 'change' } // ,
/*          { min: 3, max: 16, message: 'Length should be 3 to 16', trigger: 'blur' } */
        ]
      }
    }

  },  // data



  created () {

    this.$events.fire(ENABLE_SAVE_EVENT)

    if (!this.site) {
      this.site = this.getTableStruct('sites')
    }

    if (this.addSite && this.site && this.status) {
      this.site.status = this.status
    }

    if (this.siteData && !this.addSite) {

      if (this.siteData.struct_id) {
        this.site.structureId = this.siteData.struct_id
      }

      this.loc =
      [this.originalSite.region,
        this.originalSite.state,
        this.originalSite.district,
        this.originalSite.subdistrict]

    }

   if (this.addSite && this.candidate && this.site) {
     this.candidate.actualLat = this.site.latitude
     this.candidate.actualLng = this.site.longitude
   }

  }
}

</script>



// WEBPACK FOOTER //
// SiteAction.vue?7f184ec8